import { AgentListEntryRemoteDto } from 'src/generated/signalR/agent-list-entry-remote-dto';

export class AgentListUpdated {
   public static readonly type = '[AgentList] Updated';

   constructor(public data: AgentListEntryRemoteDto[]) {}
}
